import type { RepairIntakeComponentEntry, RepairIntakeFormData } from "@/store/useRepairIntakeStore";

export type SectionNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export const stepDefinitions = [
  { key: "section1", title: "Section 1: Component Information" },
  { key: "section2", title: "Section 2: UT Information" },
  { key: "section3", title: "Section 3: Design & Operating Conditions" },
  { key: "section4", title: "Section 4: Service" },
  { key: "section5", title: "Section 5: Defect Details" },
  { key: "section6", title: "Section 6: Leak Information" },
  { key: "section7", title: "Section 7: Repair Conditions" },
  { key: "section8", title: "Section 8: Details" },
  { key: "section9", title: "Section 9: Attachments" },
] as const;

export type StepDefinition = (typeof stepDefinitions)[number];
export type SectionKey = StepDefinition["key"];

export const componentTypeOptions = [
  "Straight Pipe",
  "90",
  "Tee",
  "Reducer",
  "Flange",
  "Valve",
  "45",
  "Dummy Leg",
] as const;

export const repairTypeOptions = ["Wrap Only", "Trap", "Patch", "Corrosion Protection"] as const;

export const defectTypeOptions = [
  "Pinhole",
  "External Corrosion",
  "Internal Corrosion",
  "Pitting",
  "General wall loss",
  "Gouge",
  "Dent",
  "Weld Defect",
] as const;

export const desiredRepairLifeOptions = ["5 years (standard)", "10 years", "20 years", "Other"] as const;

export const getStepNumber = (sectionKey: SectionKey) => Number(sectionKey.replace("section", "")) as SectionNumber;

export const createEmptyComponentEntry = (): RepairIntakeComponentEntry => ({
  nominalPipeSize: "",
  outsideDiameter: "",
  schedule: "",
  nominalWallThickness: "",
});

export const createDefectLengthEntry = (
  index: number,
  current?: RepairIntakeFormData["section5"]["defectLengthEntries"][number]
) => ({
  componentLabel: `Component ${index + 1}`,
  diameterOrNPS: current?.diameterOrNPS ?? "",
  defectLength: current?.defectLength ?? "",
});

export const createDesiredRepairLengthEntry = (
  index: number,
  current?: RepairIntakeFormData["section5"]["desiredRepairLengthEntries"][number]
) => ({
  componentLabel: `Component ${index + 1}`,
  diameterOrNPS: current?.diameterOrNPS ?? "",
  desiredRepairLength: current?.desiredRepairLength ?? "",
});

export const withComponentLabels = (values: RepairIntakeFormData): RepairIntakeFormData => ({
  ...values,
  section5: {
    ...values.section5,
    defectLengthEntries: values.section5.defectLengthEntries.map((entry, index) => ({
      ...entry,
      componentLabel: `Component ${index + 1}`,
    })),
    desiredRepairLengthEntries: values.section5.desiredRepairLengthEntries.map((entry, index) => ({
      ...entry,
      componentLabel: `Component ${index + 1}`,
    })),
  },
});
